import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'striphtml2'
})

export class StripHtmlPipe2 implements PipeTransform {
    transform(value: string): any {
        return value?value.replace(/<.*?>/g, ''):null; // replace tags
    }
}